import { render } from "./systemControlMapping.vue?vue&type=template&id=5c20f1e0&scoped=true&ts=true"
import script from "./systemControlMapping.vue?vue&type=script&lang=ts"
export * from "./systemControlMapping.vue?vue&type=script&lang=ts"

import "./systemControlMapping.vue?vue&type=style&index=0&id=5c20f1e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c20f1e0"]])

export default __exports__